function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
	summary.setAttribute("role", "button");
	summary.setAttribute(
		"aria-expanded",
		summary.parentNode.hasAttribute("open")
	);

	if (summary.nextElementSibling.getAttribute("id")) {
		summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	}

	summary.addEventListener("click", event => {
		event.currentTarget.setAttribute(
			"aria-expanded",
			!event.currentTarget.closest("details").hasAttribute("open")
		);
	});

	if (summary.closest("header-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = event => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);

	elementToFocus.focus();

	if (
		elementToFocus.tagName === "INPUT" &&
		["search", "text", "email", "url"].includes(elementToFocus.type) &&
		elementToFocus.value
	) {
		elementToFocus.setSelectionRange(0, elementToFocus.value.length);
	}
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(":focus-visible");
} catch (e) {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = [
		"ARROWUP",
		"ARROWDOWN",
		"ARROWLEFT",
		"ARROWRIGHT",
		"TAB",
		"ENTER",
		"SPACE",
		"ESCAPE",
		"HOME",
		"END",
		"PAGEUP",
		"PAGEDOWN",
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener("keydown", event => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener("mousedown", event => {
		mouseClick = true;
	});

	window.addEventListener(
		"focus",
		() => {
			if (currentFocusedElement)
				currentFocusedElement.classList.remove("focused");

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add("focused");
		},
		true
	);
}

function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach(video => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + "pauseVideo" + '","args":""}',
			"*"
		);
	});
	document.querySelectorAll(".js-vimeo").forEach(video => {
		video.contentWindow.postMessage('{"method":"pause"}', "*");
	});
	document.querySelectorAll("video").forEach(video => video.pause());
	document.querySelectorAll("product-model").forEach(model => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;

	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector("input");
		this.changeEvent = new Event("change", { bubbles: true });

		this.input.addEventListener("change", this.onInputChange.bind(this));
		this.querySelectorAll("button").forEach(button =>
			button.addEventListener("click", this.onButtonClick.bind(this))
		);
	}

	quantityUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.validateQtyRules();
		this.quantityUpdateUnsubscriber = subscribe(
			PUB_SUB_EVENTS.quantityUpdate,
			this.validateQtyRules.bind(this)
		);
	}

	disconnectedCallback() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber();
		}
	}

	onInputChange(event) {
		this.validateQtyRules();
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === "plus"
			? this.input.stepUp()
			: this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}

	validateQtyRules() {
		const value = parseInt(this.input.value);
		if (this.input.min) {
			const min = parseInt(this.input.min);
			const buttonMinus = this.querySelector(
				".quantity__button[name='minus']"
			);
			buttonMinus.classList.toggle("disabled", value <= min);
		}
		if (this.input.max) {
			const max = parseInt(this.input.max);
			const buttonPlus = this.querySelector(
				".quantity__button[name='plus']"
			);
			buttonPlus.classList.toggle("disabled", value >= max);
		}
	}
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options["method"] || "post";
	var params = options["parameters"] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for (var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(
		options["hideElement"] || province_domid
	);

	Shopify.addListener(
		this.countryEl,
		"change",
		Shopify.bind(this.countryHandler, this)
	);

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute("data-provinces");
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = "none";
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement("option");
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector("details");

		this.addEventListener("keyup", this.onKeyUp.bind(this));
		this.addEventListener("focusout", this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll("summary").forEach(summary =>
			summary.addEventListener("click", this.onSummaryClick.bind(this))
		);
		this.querySelectorAll("button:not(.localization-selector)").forEach(
			button =>
				button.addEventListener("click", this.onCloseButtonClick.bind(this))
		);
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(
					event,
					this.mainDetailsToggle.querySelector("summary")
			  )
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const parentMenuElement = detailsElement.closest(".has-submenu");
		const isOpen = detailsElement.hasAttribute("open");
		const reducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)"
		);

		function addTrapFocus() {
			trapFocus(
				summaryElement.nextElementSibling,
				detailsElement.querySelector("button")
			);
			summaryElement.nextElementSibling.removeEventListener(
				"transitionend",
				addTrapFocus
			);
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(event, summaryElement)
				: this.openMenuDrawer(summaryElement);

			if (window.matchMedia("(max-width: 990px)")) {
				document.documentElement.style.setProperty(
					"--viewport-height",
					`${window.innerHeight}px`
				);
			}
		} else {
			setTimeout(() => {
				detailsElement.classList.add("menu-opening");
				summaryElement.setAttribute("aria-expanded", true);
				parentMenuElement &&
					parentMenuElement.classList.add("submenu-open");
				!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener(
							"transitionend",
							addTrapFocus
					  );
			}, 100);
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});
		summaryElement.setAttribute("aria-expanded", true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event === undefined) return;

		this.mainDetailsToggle.classList.remove("menu-opening");
		this.mainDetailsToggle.querySelectorAll("details").forEach(details => {
			details.removeAttribute("open");
			details.classList.remove("menu-opening");
		});
		this.mainDetailsToggle
			.querySelectorAll(".submenu-open")
			.forEach(submenu => {
				submenu.classList.remove("submenu-open");
			});
		document.body.classList.remove(
			`overflow-hidden-${this.dataset.breakpoint}`
		);
		removeTrapFocus(elementToFocus);
		this.closeAnimation(this.mainDetailsToggle);
	}

	onFocusOut() {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute("open") &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest("details");
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		const parentMenuElement = detailsElement.closest(".submenu-open");
		parentMenuElement && parentMenuElement.classList.remove("submenu-open");
		detailsElement.classList.remove("menu-opening");
		detailsElement
			.querySelector("summary")
			.setAttribute("aria-expanded", false);
		removeTrapFocus(detailsElement.querySelector("summary"));
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = time => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute("open");
				if (detailsElement.closest("details[open]")) {
					trapFocus(
						detailsElement.closest("details[open]"),
						detailsElement.querySelector("summary")
					);
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.querySelector(".section-header");
		this.borderOffset =
			this.borderOffset ||
			this.closest(".header-wrapper").classList.contains(
				"header-wrapper--border-bottom"
			)
				? 1
				: 0;
		document.documentElement.style.setProperty(
			"--header-bottom-position",
			`${parseInt(
				this.header.getBoundingClientRect().bottom - this.borderOffset
			)}px`
		);
		this.header.classList.add("menu-open");

		setTimeout(() => {
			this.mainDetailsToggle.classList.add("menu-opening");
		});

		summaryElement.setAttribute("aria-expanded", true);
		window.addEventListener("resize", this.onResize);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}

	closeMenuDrawer(event, elementToFocus) {
		if (!elementToFocus) return;
		super.closeMenuDrawer(event, elementToFocus);
		this.header.classList.remove("menu-open");
		window.removeEventListener("resize", this.onResize);
	}

	onResize = () => {
		this.header &&
			document.documentElement.style.setProperty(
				"--header-bottom-position",
				`${parseInt(
					this.header.getBoundingClientRect().bottom - this.borderOffset
				)}px`
			);
		document.documentElement.style.setProperty(
			"--viewport-height",
			`${window.innerHeight}px`
		);
	};
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			"click",
			this.hide.bind(this, false)
		);
		this.addEventListener("keyup", event => {
			if (event.code.toUpperCase() === "ESCAPE") this.hide();
		});
		if (this.classList.contains("media-modal")) {
			this.addEventListener("pointerup", event => {
				if (
					event.pointerType === "mouse" &&
					!event.target.closest("deferred-media, product-model")
				)
					this.hide();
			});
		} else {
			this.addEventListener("click", event => {
				if (event.target === this) this.hide();
			});
		}
	}

	connectedCallback() {
		if (this.moved) return;
		this.moved = true;
		document.body.appendChild(this);
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector(".template-popup");
		document.body.classList.add("overflow-hidden");
		this.setAttribute("open", "");
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		document.body.classList.remove("overflow-hidden");
		document.body.dispatchEvent(new CustomEvent("modalClosed"));
		this.removeAttribute("open");
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector("button");

		if (!button) return;
		button.addEventListener("click", () => {
			const modal = document.querySelector(this.getAttribute("data-modal"));
			if (modal) modal.show(button);
		});
	}
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener("click", this.loadContent.bind(this));
	}

	loadContent(focus = true) {
		window.pauseAllMedia();
		if (!this.getAttribute("loaded")) {
			const content = document.createElement("div");
			content.appendChild(
				this.querySelector("template").content.firstElementChild.cloneNode(
					true
				)
			);

			this.setAttribute("loaded", true);
			const deferredElement = this.appendChild(
				content.querySelector("video, model-viewer, iframe")
			);
			if (focus) deferredElement.focus();
			if (
				deferredElement.nodeName == "VIDEO" &&
				deferredElement.getAttribute("autoplay")
			) {
				// force autoplay for safari
				deferredElement.play();
			}
		}
	}
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector('[id^="Slider-"]');
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.enableSliderLooping = false;
		this.currentPageElement = this.querySelector(".slider-counter--current");
		this.pageTotalElement = this.querySelector(".slider-counter--total");
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		this.initPages();
		const resizeObserver = new ResizeObserver(entries => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener("scroll", this.update.bind(this));
		this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
		this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
	}

	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter(
			element => element.clientWidth > 0
		);
		if (this.sliderItemsToShow.length < 2) return;
		this.sliderItemOffset =
			this.sliderItemsToShow[1].offsetLeft -
			this.sliderItemsToShow[0].offsetLeft;
		this.slidesPerPage = Math.floor(
			(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
				this.sliderItemOffset
		);
		this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
		this.update();
	}

	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
		this.initPages();
	}

	update() {
		// Temporarily prevents unneeded updates resulting from variant changes
		// This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
		if (!this.slider || !this.nextButton) return;

		const previousPage = this.currentPage;
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

		if (this.currentPageElement && this.pageTotalElement) {
			this.currentPageElement.textContent = this.currentPage;
			this.pageTotalElement.textContent = this.totalPages;
		}

		if (this.currentPage != previousPage) {
			this.dispatchEvent(
				new CustomEvent("slideChanged", {
					detail: {
						currentPage: this.currentPage,
						currentElement: this.sliderItemsToShow[this.currentPage - 1],
					},
				})
			);
		}

		if (this.enableSliderLooping) return;

		if (this.isSlideVisible(this.sliderItemsToShow[0])) {
			this.prevButton.setAttribute("disabled", "disabled");
			this.prevButton.style.opacity = "0";
		} else {
			this.prevButton.removeAttribute("disabled");
			this.prevButton.style.opacity = "1";
		}

		if (
			this.isSlideVisible(
				this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
			)
		) {
			this.nextButton.setAttribute("disabled", "disabled");
		} else {
			this.nextButton.removeAttribute("disabled");
		}
	}

	isSlideVisible(element, offset = 0) {
		const lastVisibleSlide =
			this.slider.clientWidth + this.slider.scrollLeft - offset;
		return (
			element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
			element.offsetLeft >= this.slider.scrollLeft
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const step = event.currentTarget.dataset.step || 1;
		this.slideScrollPosition =
			event.currentTarget.name === "next"
				? this.slider.scrollLeft + step * this.sliderItemOffset
				: this.slider.scrollLeft - step * this.sliderItemOffset;
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		});
	}
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
	constructor() {
		super();
		this.sliderControlWrapper = this.querySelector(".slider-buttons");
		this.enableSliderLooping = true;

		if (!this.sliderControlWrapper) return;

		this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
		if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

		this.sliderControlLinksArray = Array.from(
			this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
		);
		this.sliderControlLinksArray.forEach(link =>
			link.addEventListener("click", this.linkToSlide.bind(this))
		);
		this.slider.addEventListener(
			"scroll",
			this.setSlideVisibility.bind(this)
		);
		this.setSlideVisibility();

		if (this.slider.getAttribute("data-autoplay") === "true")
			this.setAutoPlay();
	}

	setAutoPlay() {
		this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
		this.autoplaySpeed = this.slider.dataset.speed * 1000;

		this.sliderAutoplayButton.addEventListener(
			"click",
			this.autoPlayToggle.bind(this)
		);
		this.addEventListener("mouseover", this.focusInHandling.bind(this));
		this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
		this.addEventListener("focusin", this.focusInHandling.bind(this));
		this.addEventListener("focusout", this.focusOutHandling.bind(this));

		this.play();
		this.autoplayButtonIsSetToPlay = true;
	}

	onButtonClick(event) {
		super.onButtonClick(event);
		const isFirstSlide = this.currentPage === 1;
		const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

		if (!isFirstSlide && !isLastSlide) return;

		if (isFirstSlide && event.currentTarget.name === "previous") {
			this.slideScrollPosition =
				this.slider.scrollLeft +
				this.sliderFirstItemNode.clientWidth *
					this.sliderItemsToShow.length;
		} else if (isLastSlide && event.currentTarget.name === "next") {
			this.slideScrollPosition = 0;
		}
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		});
	}

	update() {
		super.update();
		this.sliderControlButtons = this.querySelectorAll(
			".slider-counter__link"
		);
		this.prevButton.removeAttribute("disabled");

		if (!this.sliderControlButtons.length) return;

		this.sliderControlButtons.forEach(link => {
			link.classList.remove("slider-counter__link--active");
			link.removeAttribute("aria-current");
		});
		this.sliderControlButtons[this.currentPage - 1].classList.add(
			"slider-counter__link--active"
		);
		this.sliderControlButtons[this.currentPage - 1].setAttribute(
			"aria-current",
			true
		);
	}

	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
		this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
		this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
	}

	focusOutHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton ||
			this.sliderAutoplayButton.contains(event.target);
		if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
		this.play();
	}

	focusInHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton ||
			this.sliderAutoplayButton.contains(event.target);
		if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
			this.play();
		} else if (this.autoplayButtonIsSetToPlay) {
			this.pause();
		}
	}

	play() {
		this.slider.setAttribute("aria-live", "off");
		clearInterval(this.autoplay);
		this.autoplay = setInterval(
			this.autoRotateSlides.bind(this),
			this.autoplaySpeed
		);
	}

	pause() {
		this.slider.setAttribute("aria-live", "polite");
		clearInterval(this.autoplay);
	}

	togglePlayButtonState(pauseAutoplay) {
		if (pauseAutoplay) {
			this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
			this.sliderAutoplayButton.setAttribute(
				"aria-label",
				window.accessibilityStrings.playSlideshow
			);
		} else {
			this.sliderAutoplayButton.classList.remove(
				"slideshow__autoplay--paused"
			);
			this.sliderAutoplayButton.setAttribute(
				"aria-label",
				window.accessibilityStrings.pauseSlideshow
			);
		}
	}

	autoRotateSlides() {
		const slideScrollPosition =
			this.currentPage === this.sliderItems.length
				? 0
				: this.slider.scrollLeft +
				  this.slider.querySelector(".slideshow__slide").clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}

	setSlideVisibility() {
		this.sliderItemsToShow.forEach((item, index) => {
			const linkElements = item.querySelectorAll("a");
			if (index === this.currentPage - 1) {
				if (linkElements.length)
					linkElements.forEach(button => {
						button.removeAttribute("tabindex");
					});
				item.setAttribute("aria-hidden", "false");
				item.removeAttribute("tabindex");
			} else {
				if (linkElements.length)
					linkElements.forEach(button => {
						button.setAttribute("tabindex", "-1");
					});
				item.setAttribute("aria-hidden", "true");
				item.setAttribute("tabindex", "-1");
			}
		});
	}

	linkToSlide(event) {
		event.preventDefault();
		const slideScrollPosition =
			this.slider.scrollLeft +
			this.sliderFirstItemNode.clientWidth *
				(this.sliderControlLinksArray.indexOf(event.currentTarget) +
					1 -
					this.currentPage);
		this.slider.scrollTo({
			left: slideScrollPosition,
		});
	}
}

customElements.define("slideshow-component", SlideshowComponent);
function initImageGallery() {
  const allMedia = document.querySelectorAll(
    '.image-magnify-hover, .component--product--media__image, .image-magnify-lightbox'
  );
  const galleryMedia = Array.from(allMedia).filter((media) => {
    const parent = media.closest('.slider_variant_image');
    return !parent || parent.classList.contains('show_var_image');
  });

  // Build media array
  const preloadedMedia = galleryMedia.map(media => {
    if (media.tagName.toLowerCase() === 'img') {
      const img = new Image();
      img.src = media.src;
      img.alt = media.alt || '';
      return { type: 'image', element: img };
    } else if (media.tagName.toLowerCase() === 'video') {
      const videoClone = media.cloneNode(true);
      videoClone.removeAttribute('id');
      videoClone.controls = true;
      videoClone.preload = 'auto';
      return { type: 'video', element: videoClone };
    }
  });

  const modal = document.getElementById('image-gallery-modal');
  const modalContent = modal.querySelector('.gallery-main-image'); // We'll replace this dynamically
  const closeBtn = modal.querySelector('.gallery-close');
  const prevBtn = modal.querySelector('.gallery-prev');
  const nextBtn = modal.querySelector('.gallery-next');
  const dotsContainer = modal.querySelector('.gallery-dots');

  let currentIndex = 0;
  let startX = 0;

  function renderDots() {
    dotsContainer.innerHTML = '';
    preloadedMedia.forEach((_, index) => {
      const dot = document.createElement('span');
      dot.classList.add('gallery-dot');
      if (index === currentIndex) dot.classList.add('active');
      dot.addEventListener('click', () => openModal(index));
      dotsContainer.appendChild(dot);
    });
  }

  function showMedia(index) {
    const container = modal.querySelector('.gallery-main-image');
    const newMedia = preloadedMedia[index].element.cloneNode(true);
    container.replaceWith(newMedia);
    newMedia.classList.add('gallery-main-image');
  }

  function openModal(index) {
    currentIndex = index;
    showMedia(currentIndex);
    modal.classList.remove('hidden');
    document.body.classList.add('scroll_lock');
    renderDots();
  }

  function closeModal() {
    modal.classList.add('hidden');
    document.body.classList.remove('scroll_lock');
  }

  function showNext() {
    currentIndex = (currentIndex + 1) % preloadedMedia.length;
    showMedia(currentIndex);
    renderDots();
  }

  function showPrev() {
    currentIndex = (currentIndex - 1 + preloadedMedia.length) % preloadedMedia.length;
    showMedia(currentIndex);
    renderDots();
  }

  // Bind click events
  galleryMedia.forEach((media, index) => {
    media.addEventListener('click', () => openModal(index));
  });

  document.querySelectorAll('.mobile-gallery-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const targetSelector = btn.getAttribute('data-target-image');
      const targetMedia = document.querySelector(targetSelector);
      const index = galleryMedia.indexOf(targetMedia);
      if (index >= 0) openModal(index);
    });
  });

  closeBtn.addEventListener('click', closeModal);
  nextBtn.addEventListener('click', showNext);
  prevBtn.addEventListener('click', showPrev);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') showNext();
    if (e.key === 'ArrowLeft') showPrev();
  });

  modal.querySelector('.gallery-backdrop').addEventListener('click', closeModal);

  // Mobile swipe handling
  modal.addEventListener('touchstart', (e) => {
    startX = e.changedTouches[0].screenX;
  });

  modal.addEventListener('touchend', (e) => {
    let diff = startX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? showNext() : showPrev();
    }
  });
}
function initImageMagnify(zoomRatio = 2) {
	function createOverlay(image, cancelCheck) {
	const overlayImage = document.createElement('img');
	overlayImage.setAttribute('src', image.src);

	const overlay = document.createElement('div');
	prepareOverlay(overlay, overlayImage);

	image.style.opacity = '50%';
	toggleLoadingSpinner(image);

	overlayImage.onload = () => {
		toggleLoadingSpinner(image);

		if (cancelCheck()) {
		image.style.opacity = '100%';
		return;
		}

		image.parentElement.insertBefore(overlay, image);
		image.style.opacity = '100%';
	};

	return overlay;
	}

  function prepareOverlay(container, image) {
		container.setAttribute('class', 'image-magnify-full-size');
		container.setAttribute('aria-hidden', 'true');
		container.style.backgroundImage = `url('${image.src}')`;
		container.style.backgroundColor = 'var(--gradient-background)';
		container.style.position = 'absolute';
		container.style.top = '0';
		container.style.left = '0';
		container.style.width = '100%';
		container.style.height = '100%';
		container.style.pointerEvents = 'none';
		container.style.zIndex = '10';
	}

	function toggleLoadingSpinner(image, forceHide = false) {
	const loadingSpinner = image.parentElement?.parentElement?.querySelector(`.loading-overlay__spinner`);
	if (loadingSpinner) {
		if (forceHide) {
		loadingSpinner.classList.add('hidden');
		} else {
		loadingSpinner.classList.toggle('hidden');
		}
	}
	}

  function moveWithHover(image, event, zoomRatio, overlay) {
		const ratio = image.height / image.width;
		const container = image.getBoundingClientRect();
		const xPosition = event.clientX - container.left;
		const yPosition = event.clientY - container.top;
		const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
		const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

		overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
		overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
	}

	function magnifyOnHover(image, zoomRatio) {
	let overlay = null;
	let cancel = false;

	image.addEventListener('mouseenter', () => {
		cancel = false;
		overlay = createOverlay(image, () => cancel);
	});

	image.addEventListener('mousemove', (event) => {
		if (overlay) {
		moveWithHover(image, event, zoomRatio, overlay);
		}
	});

	image.addEventListener('mouseleave', () => {
		cancel = true;
		if (overlay) {
		overlay.remove();
		overlay = null;
		}
		image.style.opacity = '100%';
		toggleLoadingSpinner(image, true);
	});
	}

  function magnifyToggleOnClick(image, zoomRatio) {
    let overlay = null;

    image.addEventListener('click', (event) => {
      event.preventDefault();

      if (!overlay) {
        overlay = createOverlay(image);
        moveWithHover(image, event, zoomRatio, overlay);

        overlay.addEventListener('mousemove', (e) => {
          moveWithHover(image, e, zoomRatio, overlay);
        });

        image.setAttribute('data-magnified', 'true');
      } else {
        overlay.remove();
        overlay = null;
        image.removeAttribute('data-magnified');
      }
    });
  }

  const images = document.querySelectorAll('.image-magnify-lightbox');
  const isDesktop = window.innerWidth > 991;

  images.forEach(image => {
    image.onclick = null; // clear any existing click handler

    if (isDesktop) {
    //   magnifyOnHover(image, zoomRatio);
    } else {
    //   magnifyToggleOnClick(image, zoomRatio);
    }
  });

  console.log(`✅ Image magnify initialized (${isDesktop ? 'hover' : 'click toggle'} mode)`);
}


let splideInstance;

function moveFullSlide() {
  const slider = document.querySelector('.product-main-slider .splide__list');
  const fullSlide = slider?.querySelector('.product__media-item--full');
  if (fullSlide) {
    const slides = Array.from(slider.children);
    const secondSlide = slides[1];
    if (secondSlide && secondSlide !== fullSlide) {
      slider.insertBefore(fullSlide, secondSlide);
    }
  }
}

function initSplide() {
  if (window.innerWidth <= 767) {
    console.log('slider assign')
    const fullWidthSeen = document.querySelector('.product-main-slider .full-width-seen');
    if (fullWidthSeen) fullWidthSeen.remove();

    moveFullSlide();

    splideInstance = new Splide('.product-main-slider', {
  type: 'slide',
  perPage: 1.5,
  perMove: 1,
  focus: 'center',
  arrows: false,
  gap: '8px',
  pagination: false,
  drag: true,
  dragMinThreshold: { mouse: 0, touch: 0 },
  swipeDistanceThreshold: 20,
  flickPower: 200,
}).mount();

  } else if (window.innerWidth > 767 && splideInstance) {
    splideInstance.destroy();
    splideInstance = null;
  }
}
function checkBundlePreorderStateGlobal(event) {
  const input = event.target;
  const relationKey = input?.getAttribute('data-relation');
  if (!relationKey) return;

  const bundleItem = document.querySelector(`.bundle_product_item_main[data-relation="${relationKey}"]`);
  if (!bundleItem) return;

  // 1) Build the selected variant title (from radios for this relation)
  const selectedInputs = bundleItem.querySelectorAll(`input[type=radio][data-relation="${relationKey}"]:checked`);
  const selectedParts = Array.from(selectedInputs, el => (el.value || '').trim());
  const fullVariantTitle = selectedParts.join(' / ').trim();

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  console.log(`Bundle [${relationKey}] → Variant Title:`, fullVariantTitle);

  // 2) Parse embedded variant JSON
  const variantDataJSON = bundleItem.querySelector('.bundle_pro_info')?.textContent?.trim() || '[]';
  let variants = [];
  try {
    variants = JSON.parse(variantDataJSON);
  } catch (e) {
    console.warn(`Invalid JSON in .bundle_pro_info for relation "${relationKey}":`, e);
    variants = [];
  }

  // 3) Match the correct variant
  //    - If multiple options are selected (contains "/"), do exact normalized match against full title.
  //    - If only one part is selected (likely size), match against the LAST segment of the variant title.
  //    - Fallback: single-variant product -> use that one.
  const key = norm(fullVariantTitle);
  let matchedVariant = null;

  if (variants.length === 1) {
    matchedVariant = variants[0];
  } else if (key && fullVariantTitle.includes('/')) {
    // exact match on full title
    matchedVariant = variants.find(v => norm(v?.title) === key) || null;
  } else if (key) {
    // size-only (or single option) selection: compare against last segment
    matchedVariant = variants.find(v => {
      const parts = (v?.title || '').split('/').map(s => norm(s));
      const last = parts[parts.length - 1]; // assume size is last
      return last === key;
    }) || null;
  }

  let isPreorder = false;

  if (matchedVariant) {
    const q = matchedVariant.inventory_quantity;
    // Avoid JS coercion: null <= 0 → true (we don't want that)
    const outOfStock = Number.isFinite(q) ? q <= 0 : false;
    const continueSelling = matchedVariant.inventory_policy === 'continue';

    console.log('Matched Variant:', matchedVariant);
    console.log('Out of Stock:', outOfStock, '(raw inventory_quantity:', q, ')');
    console.log('Continue Selling:', continueSelling);

    isPreorder = outOfStock && continueSelling;
    if (isPreorder) {
      console.log('→ Preorder condition met for:', matchedVariant.title);
    }
  } else {
    console.warn(`No variant matched for title "${fullVariantTitle}" in relation "${relationKey}"`);
  }

  // 4) Toggle preorder class
  bundleItem.classList.toggle('bundle-preorder-active', isPreorder);
}
class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener("change", this.onVariantChange);
		setTimeout(function(){
					document.querySelectorAll('.product-form__input input[type=radio]:checked')
    .forEach(input => checkBundlePreorderStateGlobal({ target: input }));
				},500);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateMasterId();
		this.toggleAddButton(true, "", false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.updateVariantStatuses();

		if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          if (!window.location.pathname.includes('/pages/giving-confidence')) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
          this.updateProductPageElements();
        
          const formSubmitBtn = document.querySelector('.pdp-2025-form-submit');
        
          if (this.currentVariant.available === false && this.currentVariant.inventory_policy !== 'continue') {
            formSubmitBtn?.classList.add('oos_active');
          } else {
            formSubmitBtn?.classList.remove('oos_active');
          }
        }

	}

	updateProductPageElements() {
		let pdpVariantTitle = document.querySelectorAll(".pdp-variant-title"),
			preOrderTags = document.querySelectorAll(".pre-order-tag"),
			soldOutTags = document.querySelectorAll(".sold-out"),
			productStatus = document.querySelector(".product-status");
		// console.log(this.currentVariant);

		// pdpVariantTitle.forEach(
		// 	title => (title.textContent = this.currentVariant.option1)
		// );

		const { inventory_quantity, inventory_policy, available } =
			this.currentVariant;
		const showPreOrderTag =
			inventory_quantity <= 0 && inventory_policy === "continue";

		const showSoldOutTag = available == false;
		// console.log(showPreOrderTag);

		preOrderTags.forEach(tag => {
			// console.log(tag);
			// console.log(showPreOrderTag);
			if (showPreOrderTag) {
				tag.classList.remove("tw-hidden");
			} else {
				tag.classList.add("tw-hidden");
			}
		});

		if (showSoldOutTag) {
			productStatus.classList.add("tw-hidden");
		} else {
			productStatus.classList.remove("tw-hidden");
		}

		soldOutTags.forEach(tag => {
			if (showSoldOutTag) {
				tag.classList.remove("tw-hidden");
			} else {
				tag.classList.add("tw-hidden");
			}
		});

		// pdpVariantTitle.textContent = this.currentVariant.option1;
		//Sticky Bar Start
		const stickyBarPDP = document.querySelector(".product_bottom_cta"),
			selectedVariantTitle = stickyBarPDP.querySelector(
				".selected-variant-title"
			),
			selectedFeaturedImage = stickyBarPDP.querySelector(
				".selected-featured-image"
			),
			selectedVariantId = stickyBarPDP.querySelector(
				"input.selected-variant-id"
			),
			submitButton = stickyBarPDP.querySelector("button");

		selectedVariantTitle.textContent = this.currentVariant.title;
		selectedFeaturedImage.src = this.currentVariant.featured_image.src;
		selectedVariantId.value = this.currentVariant.id;
		if (this.currentVariant.available == false) {
			submitButton.disabled = true;
			submitButton.innerText = "sold out";
		} else {
			submitButton.disabled = false;
			submitButton.innerText = "add to bag";
		}
		//Sticky Bar End
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll("select"),
			select => select.value
		);
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find(variant => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateMedia() {
		const mainProductSection = document.querySelector('.main-product-section');
        if (mainProductSection?.getAttribute('gallery-enable') === 'true') {
            if (!this.currentVariant || !this.currentVariant.featured_media) return;
        
            const sectionId = 'main-product-pdp2025';
            const variantId = this.currentVariant.id;
            const url = `${window.location.pathname}?section_id=${sectionId}&variant=${variantId}`;
        
            const seenBlock = document.querySelector('.full-width-seen');
        
            fetch(url)
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
        
                const newGallery = doc.querySelector('media-gallery');
                const currentGallery = document.querySelector('media-gallery');
        
                if (newGallery && currentGallery) {
                  currentGallery.replaceWith(newGallery);
                }
        
                const newSliderList = document.querySelector('media-gallery .splide__list');
                if (seenBlock && newSliderList && !newSliderList.contains(seenBlock)) {
                  newSliderList.appendChild(seenBlock);
                }
        
                initSplide();
                initImageMagnify(2);
				setTimeout(initImageGallery(), 1000);
              })
              .catch(error => {
                console.error('Error updating media gallery:', error);
              });
        } else {
            if (!this.currentVariant || !this.currentVariant.featured_media) return;
        
            const mediaGalleries = document.querySelectorAll(
              `[id^="MediaGallery-${this.dataset.section}"]`
            );
        
            mediaGalleries.forEach(mediaGallery =>
              mediaGallery.setActiveMedia(
                `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
                true
              )
            );
        
            const modalContent = document.querySelector(
              `#ProductModal-${this.dataset.section} .product-media-modal__content`
            );
            if (!modalContent) return;
        
            const newMediaModal = modalContent.querySelector(
              `[data-media-id="${this.currentVariant.featured_media.id}"]`
            );
            if (newMediaModal) {
              modalContent.prepend(newMediaModal);
            }
        }
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === "false") return;
		window.history.replaceState(
			{},
			"",
			`${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(
			`Share-${this.dataset.section}`
		);
		if (!shareButton || !shareButton.updateUrl) return;
		shareButton.updateUrl(
			`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		);
		productForms.forEach(productForm => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		});
	}

	updateVariantStatuses() {
		function initPropsScroller() {
			const scroller = document.querySelector('.props-value-scroller');
			if (!scroller) return;

			const track = scroller.querySelector('.props-value-track');
			if (!track) return;

			const cards = Array.from(track.children);

			// Clone content for infinite loop
			const cloneTrackContent = () => {
				cards.forEach(card => {
				const clone = card.cloneNode(true);
				clone.setAttribute('aria-hidden', 'true');
				track.appendChild(clone);
				});
			};
			cloneTrackContent();

			let position = 0;
			const speed = 0.5;
			let isPaused = false;
			let isDragging = false;
			let startX = 0;
			let scrollStart = 0;

			const animate = () => {
				if (!isPaused && !isDragging) {
				position -= speed;

				const halfWidth = track.scrollWidth / 2;
				if (Math.abs(position) >= halfWidth) {
					position += halfWidth; // shift forward to avoid jump
				}

				track.style.transform = `translateX(${position}px)`;
				}
				requestAnimationFrame(animate);
			};

			scroller.addEventListener("mouseenter", () => isPaused = true);
			scroller.addEventListener("mouseleave", () => isPaused = false);

			const startDrag = (e) => {
				isDragging = true;
				startX = e.pageX || e.touches[0].pageX;
				scrollStart = position;
				scroller.classList.add('dragging');
			};

			const onDrag = (e) => {
				if (!isDragging) return;
				const x = e.pageX || e.touches[0].pageX;
				const delta = x - startX;
				position = scrollStart + delta;
				track.style.transform = `translateX(${position}px)`;
			};

			const stopDrag = () => {
				isDragging = false;
				scroller.classList.remove('dragging');
			};

			animate();
		}
		const inputWrappers = [...this.querySelectorAll(".product-form__input")];

		const selectedOptions = inputWrappers.map(wrapper => {
			const selectedInput = wrapper.querySelector(":checked");
			return selectedInput ? selectedInput.value : '';
		});

		const selectedVariantId = this.currentVariant?.id || null;

			if (!selectedVariantId) {
			return;
			}
			const sectionId = document.querySelector('variant-radios')?.dataset.section || 'main-product-pdp2025';
			const url = `${window.location.pathname}?section_id=${sectionId}&variant=${selectedVariantId}`;
			fetch(url)
			.then(response => {
				if (!response.ok) throw new Error('Network response was not ok');
				return response.text();
			})
			.then(html => {
				const parser = new DOMParser();
				const doc = parser.parseFromString(html, 'text/html');
				const updatedRadios = doc.querySelector('.variant-radios');
				const props_track = doc.querySelector('.props-value-track');

				if (updatedRadios) {
					const currentRadios = document.querySelector('.variant-radios');
					const current_props_track = document.querySelector('.props-value-track');
					if (currentRadios) {
						currentRadios.replaceWith(updatedRadios);
					} 
					if (current_props_track) {
						current_props_track.replaceWith(props_track);
						initPropsScroller();
					}
				}
			})
			.catch(error => {
				console.error('❌ Failed to fetch or update variant radios:', error);
			});

	}



	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		listOfOptions.forEach(input => {
			console.log('setInputAvailability 1');
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.innerText = input.getAttribute("value");
			} else {
				input.innerText =
					window.variantStrings.unavailable_with_option.replace(
						"[value]",
						input.getAttribute("value")
					);
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector("pickup-availability");
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute("available");
			pickUpAvailability.innerHTML = "";
		}
	}

	removeErrorMessage() {
		const section = this.closest("section");
		if (!section) return;

		const productForm = section.querySelector("product-form");
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
				this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section
			}`
		)
			.then(response => response.text())
			.then(responseText => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				const destination = document.getElementById(
					`price-${this.dataset.section}`
				);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuDestination = document.getElementById(
					`Sku-${this.dataset.section}`
				);
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				);

				// Get the span element
				const submitButton = document.querySelector(
					"button.product-form__submit"
				);

				let current_price = html.querySelector(
					".price-item.price-item--regular"
				);

				if (submitButton && current_price) {
					const priceSpans = document.querySelectorAll(
						".add-to-cartBtn-price"
					);
					// console.log(priceSpans);
					priceSpans.forEach(priceSpan => {
						if (priceSpan) {
							priceSpan.remove();
						}
					});

					let spanElement = document.createElement("span");
					spanElement.classList.add("add-to-cartBtn-price");
					spanElement.classList.add("igPrice");
					spanElement.innerHTML = ` - ${current_price.innerHTML}`;
					if (
						this.currentVariant.inventory_quantity <= 0 &&
						this.currentVariant.inventory_policy === "continue"
					) {
						spanElement.classList.add("visually-hidden");
					}
					const stickyAddToCartButton =
						document.querySelector(".sticky_atc_button");
					if (this.currentVariant.inventory_quantity > 0) {
						stickyAddToCartButton.classList.remove("gPreorderBtn");
						stickyAddToCartButton.textContent = "add to bag";
					} else if (
						this.currentVariant.inventory_quantity <= 0 &&
						this.currentVariant.inventory_policy === "continue"
					) {
						stickyAddToCartButton.classList.add("gPreorderBtn");
						stickyAddToCartButton.textContent = "pre order";
					}

					if (stickyAddToCartButton) {
						// console.log(stickyAddToCartButton);
						stickyAddToCartButton.appendChild(
							spanElement.cloneNode(true)
						);
					}
				}

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						"visibility-hidden",
						skuSource.classList.contains("visibility-hidden")
					);
				}

				const price = document.getElementById(
					`price-${this.dataset.section}`
				);

				if (price) price.classList.remove("visibility-hidden");

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						"visibility-hidden",
						inventorySource.innerText === ""
					);

				const addButtonUpdated = html.getElementById(
					`ProductSubmitButton-${sectionId}`
				);
				this.toggleAddButton(
					addButtonUpdated
						? addButtonUpdated.hasAttribute("disabled")
						: true,
					window.variantStrings.soldOut
				);

				publish(PUB_SUB_EVENTS.variantChange, {
					data: {
						sectionId,
						html,
						variant: this.currentVariant,
					},
				});
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute("disabled", "disabled");
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute("disabled");
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(
			`Inventory-${this.dataset.section}`
		);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);

		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add("visibility-hidden");
		if (inventory) inventory.classList.add("visibility-hidden");
		if (sku) sku.classList.add("visibility-hidden");
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(
				this.querySelector('[type="application/json"]').textContent
			);
		return this.variantData;
	}
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	setInputAvailability(listOfOptions, listOfAvailableOptions) {
		console.log('setInputAvailability2');
		listOfOptions.forEach(input => {
			if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
				input.classList.remove("disabled");
			} else {
				input.classList.add("disabled");
			}
		});
	}

	updateOptions() {
  const allRadios = Array.from(this.querySelectorAll("input[type='radio'][name]"));

  const optionNames = [...new Set(allRadios.map(input => input.name))];

  this.options = optionNames.map(name => {
    const checked = allRadios.find(input => input.name === name && input.checked);
    return checked ? checked.value : null;
  }).filter(val => val !== null); // optional: skip nulls
}

}

customElements.define("variant-radios", VariantRadios);
function initSplideQs() {
  if (window.splideInstance) {
    window.splideInstance.destroy(true);
  }

  const sliderEl = document.querySelector('.product-main-slider-qs');
  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'slide',
      perPage: 2,
      autoplay: false,
      arrows: false,
      gap: '7px',
      pagination: false,
      drag: true,
      swipeThreshold: 20,
      flickPower: 500,
      mediaQuery: 'min',
      breakpoints: {
        768: { gap: '8.75px' },
      }
    }).mount();

    window.splideInstance = splide;

    splide.on('move', () => {
      const totalSlides = splide.Components.Slides.getLength();
      const visibleSlides = splide.options.perPage;
      const maxIndex = totalSlides - visibleSlides;

      if (splide.index >= maxIndex) {
        sliderEl.classList.add('last_gallery_slide');
      } else {
        sliderEl.classList.remove('last_gallery_slide');
      }
    });
  }
}

class QsVariantRadios extends HTMLElement {
	constructor() {
		super();
	 	initSplideQs();
		setTimeout(function(){
		document.querySelectorAll('.qs-variant-radios input[type=radio]:checked')
    .forEach(input => checkBundlePreorderStateGlobal({ target: input }));
				},500);
		this.modalContainer = document.getElementById('theme-quickshop-modal');
		this.addEventListener("change", this.onVariantChange);
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	onVariantChange() {
		const selectedOptions = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map(
			(radio) => radio.value
		);

		const currentVariant = this.getVariantData().find((variant) => {
			return !variant.options.map((opt, index) => selectedOptions[index] === opt).includes(false);
		});

		if (currentVariant) {
	this.currentVariant = currentVariant; 

	const quickshopWrapper = document.querySelector('.quickshop-main-section-wrapper');
	const sectionId = quickshopWrapper?.dataset.section || 'quickshop-section';
	const productHandleUrl = quickshopWrapper?.dataset.handle;

	if (!productHandleUrl) {
		console.error('❌ No data-handle found on .quickshop-main-section-wrapper');
		return;
	}

	// Build URL using the handle instead of window.location.pathname
	const url = `${productHandleUrl}?section_id=${sectionId}&variant=${currentVariant.id}`;

	fetch(url)
		.then(response => {
			if (!response.ok) throw new Error('Network response was not ok');
			return response.text();
		})
		.then(html => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');
			const updatedRadios = doc.querySelector('.quickshop-main-section-wrapper');

			if (updatedRadios) {
				const currentRadios = document.querySelector('.quickshop-main-section-wrapper');
				if (currentRadios) {
					currentRadios.replaceWith(updatedRadios);
				}
			}
		})
		.catch(error => {
			console.error('❌ Failed to fetch or update variant radios:', error);
		});
}

	}
}

customElements.define("qs-variant-radios", QsVariantRadios);




class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement("div");
					html.innerHTML = text;
					const recommendations = html.querySelector(
						"product-recommendations"
					);

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}

					if (
						!this.querySelector("slideshow-component") &&
						this.classList.contains("complementary-products")
					) {
						this.remove();
					}

					if (html.querySelector(".grid__item")) {
						this.classList.add("product-recommendations--loaded");
						StampedFn.loadBadges();
					}
				})
				.catch(e => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: "0px 0px 400px 0px",
		}).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);
